import { createContext, useContext, useEffect, useState } from "react";
import { T } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = window.localStorage.getItem("swm-lang");
      return saved && T[saved] ? saved : "it";
    } catch {
      return "it";
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (next) => {
    setLangState(next);
    try {
      window.localStorage.setItem("swm-lang", next);
    } catch {
      /* private mode */
    }
  };

  const t = T[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
